import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import CopyButton from 'components/v2/buttons/CopyButton';
import USER_TYPES from 'constants/UserTypes';
import formatMoney from 'utils/formatters/Money';
import DeleteButton from '../../../v2/buttons/DeleteButton';
import Spinner from '../../../ui/Spinner';
import Checkbox from '../../../v2/forms/Checkbox';
import CargomaticSelect from '../../../v2/select';
import { sluggify } from 'utils/localization/utils';
const headerDataMapping = {
    Apply: 'apply',
    'Shipment Id': 'shipment.shipment_id',
    Accessorial: 'message',
    'Carrier/Vendor Rate': 'carrier_rate',
    'Carrier/Vendor Units': 'carrier_unit_qty',
    'Carrier Note': 'carrier_note',
    'Shipper Rate': 'shipper_rate',
    'Shipper Units': 'shipper_unit_qty',
    'Shipper Note': 'shipper_note',
    Note: 'note',
    'Carrier/Vendor Note': 'carrierDeclineReasonCode',
};
class ConfirmationModalBody extends Component {
    constructor() {
        super(...arguments);
        /*
         * @nam handleAccessoriaChange updates the notes for carriers stored by acc _id
         * @params {string} id is the accessorial id that has a user created note
         * @returns null,
         */
        this.getTotal = (accessorial, type) => {
            const { carrier_rate, shipper_rate, carrier_unit_qty, shipper_unit_qty, meta: { carrier_rate: updated_carrier_rate, shipper_rate: updated_shipper_rate, carrier_unit_qty: updated_carrier_unit_qty, shipper_unit_qty: updated_shipper_unit_qty, }, } = accessorial;
            const rate = type === USER_TYPES.SHIPPER
                ? updated_shipper_rate || shipper_rate
                : updated_carrier_rate || carrier_rate;
            const units = type === USER_TYPES.SHIPPER
                ? updated_shipper_unit_qty || shipper_unit_qty
                : updated_carrier_unit_qty || carrier_unit_qty;
            if (rate) {
                if (units) {
                    return parseFloat(rate) * parseFloat(units);
                }
                return rate;
            }
            return 0;
        };
        this.handleTogglePayeeChecked = (payeeChecked) => {
            this.props.onTogglePayeeChecked(payeeChecked);
        };
        this.handleTogglePayerChecked = (payerChecked) => {
            this.props.onTogglePayerChecked(payerChecked);
        };
        this.handleAccessorialChange = (accessorialId, field) => (e) => {
            this.props.onAccessorialChange(accessorialId, {
                [field]: e.target.value,
            }, field);
        };
        this.handleSelect = (accessorialId, field) => (value) => {
            this.props.onAccessorialChange(accessorialId, {
                [field]: value,
            }, field);
        };
        this.removeSelectedAccessorial = (id) => this.props.removeAccessorial(id);
        this.renderActionsButton = (accessorialId) => {
            return (React.createElement("td", { key: "remove-button", className: "px-auto py-4  text-sm font-medium text-gray-500 border-b border-solid border-grey-lighter whitespace-nowrap" },
                React.createElement(DeleteButton, { className: "m-auto ", onClick: () => this.removeSelectedAccessorial(accessorialId) })));
        };
        this.handleApplyAllAction = ({ accessorialId, index, accessorialToUpdate: accessorialArray, }) => {
            const { accessorialUpdates } = this.props;
            const sourceRow = accessorialUpdates[accessorialId];
            const hasNegativeValue = Object.values(sourceRow.meta).some((item) => item < 0);
            const fieldsToChange = ['shipper_rate', 'shipper_unit_qty', 'shipper_note'];
            if (hasNegativeValue) {
                return;
            }
            for (let i = index + 1; i < accessorialArray.length; i++) {
                fieldsToChange.forEach((field) => {
                    var _a;
                    this.props.onAccessorialChange(accessorialArray[i], {
                        [field]: (_a = sourceRow.meta) === null || _a === void 0 ? void 0 : _a[field],
                    }, field);
                });
            }
        };
        this.renderApplyAllButton = (accessorialId, index, lastIndex, accessorialToUpdate) => {
            return index !== lastIndex ? (React.createElement("td", { className: "px-6 py-4 my-auto text-sm text-gray-500 border-b border-solid border-grey-lighter", key: accessorialId },
                React.createElement(CopyButton, { onClick: () => this.handleApplyAllAction({
                        accessorialId,
                        index,
                        accessorialToUpdate,
                    }), title: "Apply to following Accessorial" }))) : (React.createElement("div", null));
        };
        this.shouldShowCopyButton = (index, lastIndex) => {
            const { accessorialUpdates, payeeChecked } = this.props;
            if (!payeeChecked) {
                return false;
            }
            const accessorials = Object.entries(accessorialUpdates);
            const filteredAccessorials = accessorials.filter((a) => a[1].payee_type === USER_TYPES.CARRIER);
            if (filteredAccessorials.length > 2 && index !== lastIndex) {
                return true;
            }
            return false;
        };
        this.handleCopyReasonCodes = (reasonCode, index) => {
            const { accessorialUpdates } = this.props;
            const accessorials = Object.entries(accessorialUpdates);
            const filteredAccessorials = accessorials.filter((a) => a[1].payee_type === USER_TYPES.CARRIER);
            filteredAccessorials.forEach((a, i) => {
                if (i > index) {
                    this.props.onAccessorialChange(a[0], {
                        [`${a[0]}_Carrier/Vendor Note`]: reasonCode,
                    }, `${a[0]}_Carrier/Vendor Note`);
                }
            });
        };
        this.renderSelectReasonField = (field, accessorialId, keyField, index, lastIndex) => {
            const { accessorialUpdates, accessorialsReasonCodes, t } = this.props;
            return (React.createElement("td", { className: "px-6 py-4 text-sm text-gray-500 border-b border-solid border-grey-lighter", key: keyField || accessorialId },
                React.createElement("div", { className: "flex flex-row" },
                    React.createElement(CargomaticSelect, { items: accessorialsReasonCodes, value: accessorialUpdates[accessorialId].meta[field], className: "w-auto", hideLabel: true, showCaption: true, onSelect: this.handleSelect(accessorialId, field) }),
                    this.shouldShowCopyButton(index, lastIndex) && (React.createElement(CopyButton, { className: "ml-2", onClick: () => this.handleCopyReasonCodes(accessorialUpdates[accessorialId].meta[field], index), title: t('APPLY_NOTE_TO_FOLLOWING_ROWS') })))));
        };
        this.renderInputField = (field, accessorialId, keyField) => {
            const { accessorialUpdates, payerChecked, action } = this.props;
            const disabled = action === 'notify_all' && !payerChecked;
            return (React.createElement("td", { className: "px-6 py-4 text-sm text-gray-500 border-b border-solid border-grey-lighter", key: keyField || accessorialId },
                React.createElement("input", { name: `${accessorialId}_${field}`, type: "text", onChange: this.handleAccessorialChange(accessorialId, field), className: "form-field", placeholder: accessorialUpdates[accessorialId][field], value: accessorialUpdates[accessorialId].meta[field], disabled: disabled })));
        };
        this.renderField = (key, value) => {
            const { t } = this.props;
            const _displayValue = typeof value === 'string' ? t(sluggify((value || '').toString())) : value;
            return (React.createElement("td", { className: "px-6 py-4 text-sm text-gray-500 border-b border-solid border-grey-lighter", style: { minWidth: '30px', maxWidth: '30px' }, key: key }, value));
        };
        this.renderColumns = (accessorialId, rowIndex, lastIndex, accessorialToUpdate) => {
            const { accessorialUpdates, isShipperNotify, payeeChecked, t } = this.props;
            const accessorial = accessorialUpdates[accessorialId];
            if (!accessorial) {
                return;
            }
            const { _id: id, currency, payee_type } = accessorial;
            const dataColumns = this.props.headers.map((header) => {
                const field = headerDataMapping[header.value];
                let entryValue;
                if (header.value === 'Carrier/Vendor Total' ||
                    header.value === 'Shipper Total') {
                    const totalType = header.value === 'Shipper Total'
                        ? USER_TYPES.SHIPPER
                        : USER_TYPES.CARRIER;
                    entryValue = this.getTotal(accessorial, totalType);
                }
                else if (header.value === 'Accessorial') {
                    entryValue = t(sluggify(accessorial[field]));
                }
                else if (header.value === 'Shipment ID') {
                    entryValue = accessorial.shipment.shipment_id;
                }
                else if (header.value === 'Missing Docs') {
                    entryValue = accessorial.missing_docs
                        ? t(sluggify('YES'))
                        : t(sluggify('NO'));
                }
                else {
                    entryValue = accessorial[field];
                }
                if ([
                    'Shipper Rate',
                    'Shipper Total',
                    'Carrier/Vendor Rate',
                    'Carrier/Vendor Total',
                ].includes(header.value)) {
                    entryValue = formatMoney(entryValue, currency);
                }
                const keyField = `${id}_${header.value}`;
                switch (field) {
                    case 'shipper_note':
                        if (isShipperNotify)
                            return this.renderInputField(field, id, keyField);
                        return this.renderField(keyField, entryValue);
                    case 'carrier_note':
                        if (!isShipperNotify)
                            return this.renderInputField(field, id, keyField);
                        return this.renderField(keyField, entryValue);
                    case 'carrierDeclineReasonCode':
                        if (payeeChecked && payee_type === USER_TYPES.CARRIER) {
                            return this.renderSelectReasonField(keyField, id, keyField, rowIndex, lastIndex);
                        }
                        return React.createElement("td", null);
                    case 'shipper_rate':
                        if (isShipperNotify)
                            return this.renderInputField(field, id, keyField);
                        return this.renderField(keyField, entryValue);
                    case 'shipper_unit_qty':
                        if (isShipperNotify)
                            return this.renderInputField(field, id, keyField);
                        return this.renderField(keyField, entryValue);
                    case 'apply':
                        if (isShipperNotify)
                            return this.renderApplyAllButton(id, rowIndex, lastIndex, accessorialToUpdate);
                        return null;
                    default:
                        return this.renderField(keyField, entryValue);
                }
            });
            if (this.props.actionsEnabled) {
                dataColumns.push(this.renderActionsButton(id));
            }
            return dataColumns;
        };
    }
    getPayerLabel() {
        const { action, t } = this.props;
        if (action === 'approve_all') {
            return t('APPROVE_PAYER');
        }
        if (action === 'decline_all') {
            return t('DECLINE_PAYER');
        }
        return t('NOTIFY_PAYER');
    }
    getPayeeLabel() {
        const { action, t } = this.props;
        if (action === 'approve_all') {
            return t('APPROVE_PAYEE');
        }
        if (action === 'decline_all') {
            return t('DECLINE_PAYEE');
        }
        return t('NOTIFY_PAYEE');
    }
    renderHeaderField(key) {
        const { t } = this.props;
        return React.createElement("th", { key: key }, t(key));
    }
    renderHeader(headers, actionsEnabled = false) {
        const tableHeaders = headers.map((col) => this.renderHeaderField(col.localizationSlug));
        if (actionsEnabled) {
            tableHeaders.push(this.renderHeaderField('ACTIONS'));
        }
        return (React.createElement("thead", null,
            React.createElement("tr", { key: "header" }, tableHeaders)));
    }
    renderBody(accessorialUpdates) {
        if (!Object.keys(accessorialUpdates).length) {
            return null;
        }
        const accessorialToUpdate = Object.keys(accessorialUpdates);
        const lastIndex = accessorialToUpdate.length - 1;
        return (React.createElement("tbody", null, accessorialToUpdate.map((datum, index) => (React.createElement("tr", { key: datum._id || datum }, this.renderColumns(datum, index, lastIndex, accessorialToUpdate))))));
    }
    render() {
        const { accessorialUpdates, actionsEnabled, headers, payerChecked, payeeChecked, t, disablePayerResolutions, disablePayeeResolutions, disableBothPayeePayer, } = this.props;
        return (React.createElement("div", { className: "inline-block min-w-full overflow-hidden align-middle bg-white border-b rounded shadow border-grey-lighter" },
            !Object.keys(accessorialUpdates).length && (React.createElement("div", { className: "mx-auto my-4" },
                React.createElement(Spinner, { message: t('LOADING_ACCESSORIALS') }))),
            React.createElement("div", { className: "mb-4 p-4" },
                React.createElement("label", { className: "form-label mb-2" }, t('PLEASE_SELECT_ACTIONS')),
                React.createElement("div", { className: "flex items-center space-x-3" },
                    React.createElement(Checkbox, { key: "payer", className: "mb-2", checked: payerChecked, label: this.getPayerLabel(), onChange: this.handleTogglePayerChecked, info: t('SHIPPER_CONSIGNEE'), id: "payer", disabled: disableBothPayeePayer || disablePayerResolutions }),
                    React.createElement(Checkbox, { key: "payee", className: "mb-2", checked: payeeChecked, label: this.getPayeeLabel(), info: t('CARRIER_VENDOR_PARTNER'), onChange: this.handleTogglePayeeChecked, id: "payee", disabled: disableBothPayeePayer || disablePayeeResolutions }))),
            Object.keys(accessorialUpdates).length > 0 && (React.createElement("div", { className: "overflow-x-auto" },
                React.createElement("table", { className: "default-table" },
                    this.renderHeader(headers, actionsEnabled),
                    this.renderBody(accessorialUpdates))))));
    }
}
ConfirmationModalBody.propTypes = {
    headers: PropTypes.array,
    shipment: PropTypes.object,
    removeAccessorial: PropTypes.func,
    onAccessorialChange: PropTypes.func,
    accessorialUpdates: PropTypes.object,
    action: PropTypes.string,
    payerChecked: PropTypes.bool.isRequired,
    payeeChecked: PropTypes.bool.isRequired,
    onTogglePayeeChecked: PropTypes.func,
    onTogglePayerChecked: PropTypes.func,
    accessorialsReasonCodes: PropTypes.array,
    disablePayerResolutions: PropTypes.bool,
    disablePayeeResolutions: PropTypes.bool,
    disableBothPayeePayer: PropTypes.bool,
};
ConfirmationModalBody.defaultProps = {
    shipment: {},
    headers: [],
    accessorialUpdates: {},
    removeAccessorial: () => {
        return null;
    },
    onAccessorialChange: () => {
        return null;
    },
    disablePayerResolutions: false,
    disablePayeeResolutions: false,
    disableBothPayeePayer: false,
};
export default withTranslation()(ConfirmationModalBody);
